import React from 'react';
import { EPaymentMethod } from 'ui/types/core';
import { FormatCurrency } from 'utils/features/formatCurrency';

export interface IPaymentModalContentProps {
	paymentMethod: string;
	setPaymentMethod: (method: string) => void;
	totalAmount: number;
}

export const PaymentModal = ({
	paymentMethod,
	setPaymentMethod,
	totalAmount,
}: IPaymentModalContentProps) => {
	const feeRate = paymentMethod === EPaymentMethod.BankTransfer ? 0.012 : 0.031;
	const feeAmount = totalAmount * feeRate;
	const totalWithFee = totalAmount + feeAmount;

	return (
		<>
			<h2 className="text-2xl font-bold text-center mb-4">
				Select a Payment Method
			</h2>

			<fieldset className="space-y-4">
				<legend className="sr-only">Payment Method</legend>

				{/* Bank Transfer option */}
				<label
					htmlFor="bank-transfer"
					className="flex items-center space-x-2 p-4 bg-green-100 rounded-lg cursor-pointer"
				>
					<input
						type="radio"
						id="bank-transfer"
						name="payment-method"
						value={EPaymentMethod.BankTransfer}
						checked={paymentMethod === EPaymentMethod.BankTransfer}
						onChange={() => setPaymentMethod(EPaymentMethod.BankTransfer)}
						className="cursor-pointer"
						aria-label="Select Bank Transfer (ACH)"
					/>
					<span className="flex-grow">Bank Transfer (ACH)</span>
					<span className="text-sm text-gray-600">1.2% fee</span>
					<span className="ml-2 text-xs bg-green-500 text-white px-2 py-1 rounded">
						Best Choice
					</span>
				</label>

				{/* Credit Card option */}
				<label
					htmlFor="credit-card"
					className="flex items-center space-x-2 p-4 bg-gray-100 rounded-lg cursor-pointer"
				>
					<input
						type="radio"
						id="credit-card"
						name="payment-method"
						value={EPaymentMethod.CreditCard}
						checked={paymentMethod === EPaymentMethod.CreditCard}
						onChange={() => setPaymentMethod(EPaymentMethod.CreditCard)}
						className="cursor-pointer"
						aria-label="Select Credit Card"
					/>
					<span className="flex-grow">Credit Card</span>
					<span className="text-sm text-gray-600">3.1% fee</span>
				</label>
			</fieldset>

			<div className="mt-4 text-center">
				<a href="#" className="text-blue-600 underline">
					Want to mail a check? Click here
				</a>
			</div>

			<div className="mt-6 space-y-2">
				<div className="flex justify-between">
					<span>Amount</span>
					<span>
						<FormatCurrency value={totalAmount} />
					</span>
				</div>
				<div className="flex justify-between">
					<span>Convenience Fee</span>
					<span>
						<FormatCurrency value={feeAmount} />
					</span>
				</div>
				<div className="flex justify-between font-bold">
					<span>Payment Total</span>
					<span>
						<FormatCurrency value={totalWithFee} />
					</span>
				</div>
			</div>
		</>
	);
};
